<ng-container *ngIf="isMobile() !== null">
  <ng-container *ngIf="noticias()?.length > 0">
    <ng-container *ngFor="let noticia of noticias()">
      <div class="contenedor-directo" [routerLink]="[noticia?.nombreSubcanal | kebabCase, noticia?.nombreSubseccion | kebabCase, noticia?.idVideo, noticia?.tituloSeo | kebabCase]">
        <ng-container *ngIf="!isMobile()">
          <div class="desktop-noticia-container">
            <img class="desktop-noticia-imagen" src="/assets/images/banner-carta-director.webp" alt="{{ noticia.tituloVideo }}" />
            <div class="desktop-noticia-text">
              <h6 class="directo"></h6>
              <h2 class="desktop-noticia-directo">
                <a [routerLink]="[noticia?.nombreSubcanal | kebabCase, noticia?.nombreSubseccion | kebabCase, noticia?.idVideo, noticia?.tituloSeo | kebabCase]">
                  {{ noticia?.tituloVideo }}
                </a>
              </h2>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="isMobile()">
          <img class="noticia-imagen" alt="{{ noticia.tituloVideo }}" [ngSrc]="'/assets/images/banner-carta-director-movil.webp'" priority fill />
          <h2 class="noticia-directo">
            <a [routerLink]="[noticia?.nombreSubcanal | kebabCase, noticia?.nombreSubseccion | kebabCase, noticia?.idVideo, noticia?.tituloSeo | kebabCase]">
              {{ noticia?.tituloVideo }}
            </a>
          </h2>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
